/*
  Bellace scroll reveal.
  Adds "is-revealed" to .reveal elements and [data-reveal-group] wrappers
  when they scroll into view. Children of a group get --reveal-index so
  CSS can stagger them. See bellace-reveal.css.
*/
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('reveal-on')) return;

  if (!('IntersectionObserver' in window)) {
    root.classList.remove('reveal-on');
    return;
  }

  window.bellaceRevealReady = true;

  const pending = new Set();

  const reveal = (element) => {
    element.classList.add('is-revealed');
    pending.delete(element);
    observer.unobserve(element);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Also reveal anything already above the viewport (restored scroll, anchor links).
        if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) reveal(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const watch = (element) => {
    pending.add(element);
    observer.observe(element);
  };

  const setup = (scope) => {
    scope.querySelectorAll('[data-reveal-group]').forEach((group) => {
      group.querySelectorAll('.reveal-item').forEach((item, index) => {
        if (!item.style.getPropertyValue('--reveal-index')) {
          item.style.setProperty('--reveal-index', index);
        }
      });
      if (!group.classList.contains('is-revealed')) watch(group);
    });

    scope.querySelectorAll('.reveal:not(.is-revealed)').forEach(watch);
  };

  // A fast jump can skip past elements without them ever intersecting; catch those on scroll.
  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking || !pending.size) return;
      ticking = true;
      requestAnimationFrame(() => {
        pending.forEach((element) => {
          if (element.getBoundingClientRect().bottom < 0) reveal(element);
        });
        ticking = false;
      });
    },
    { passive: true }
  );

  const revealAll = (scope) => {
    scope.querySelectorAll('[data-reveal-group], .reveal').forEach(reveal);
  };

  setup(document);

  // Content swapped in later (filtered collection grids) can join the reveal.
  window.bellaceReveal = { setup, revealAll };

  // Theme editor: wire up re-rendered sections and show selected content straight away.
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:section:select', (event) => revealAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.shopify-section');
    if (section) revealAll(section);
  });
})();
